// Indian holidays and important days.
//
// IMPORTANT: Dates for lunar/Islamic-calendar holidays (Eid, Holi, Diwali,
// Onam, Janmashtami, Muharram, etc.) are best-effort estimates — actual
// observance can shift by a day or two depending on moon sighting / regional
// almanac. Treat these as informational only, not official.
//
// Each entry: { date: 'YYYY-MM-DD', name, type, regional? }
//   type: 'national' | 'religious' | 'cultural' | 'observance'
//   regional: true if it's primarily celebrated in a specific Indian region

export const HOLIDAYS = [
  // ── 2025 ─────────────────────────────────────────────────────────────────
  { date: '2025-01-01', name: "New Year's Day",          type: 'observance' },
  { date: '2025-01-14', name: 'Makar Sankranti / Pongal',type: 'cultural' },
  { date: '2025-01-26', name: 'Republic Day',            type: 'national' },
  { date: '2025-02-26', name: 'Maha Shivaratri',         type: 'religious' },
  { date: '2025-03-14', name: 'Holi',                    type: 'religious' },
  { date: '2025-03-31', name: 'Eid ul-Fitr',             type: 'religious' },
  { date: '2025-04-06', name: 'Ram Navami',              type: 'religious' },
  { date: '2025-04-10', name: 'Mahavir Jayanti',         type: 'religious' },
  { date: '2025-04-14', name: 'Ambedkar Jayanti',        type: 'national' },
  { date: '2025-04-18', name: 'Good Friday',             type: 'religious' },
  { date: '2025-05-01', name: 'Labour Day',              type: 'national' },
  { date: '2025-05-12', name: 'Buddha Purnima',          type: 'religious' },
  { date: '2025-06-07', name: 'Eid ul-Adha (Bakrid)',    type: 'religious' },
  { date: '2025-07-06', name: 'Muharram',                type: 'religious' },
  { date: '2025-08-15', name: 'Independence Day',        type: 'national' },
  { date: '2025-08-16', name: 'Janmashtami',             type: 'religious' },
  { date: '2025-08-27', name: 'Ganesh Chaturthi',        type: 'religious' },
  { date: '2025-09-05', name: 'Onam (Thiruvonam)',       type: 'cultural', regional: true },
  { date: '2025-09-05', name: 'Milad un-Nabi',           type: 'religious' },
  { date: '2025-10-02', name: 'Gandhi Jayanti',          type: 'national' },
  { date: '2025-10-02', name: 'Dussehra (Vijayadashami)',type: 'religious' },
  { date: '2025-10-20', name: 'Diwali',                  type: 'religious' },
  { date: '2025-10-23', name: 'Bhai Dooj',               type: 'religious' },
  { date: '2025-11-05', name: 'Guru Nanak Jayanti',      type: 'religious' },
  { date: '2025-12-25', name: 'Christmas Day',           type: 'religious' },

  // ── 2026 ─────────────────────────────────────────────────────────────────
  { date: '2026-01-01', name: "New Year's Day",          type: 'observance' },
  { date: '2026-01-14', name: 'Makar Sankranti / Pongal',type: 'cultural' },
  { date: '2026-01-26', name: 'Republic Day',            type: 'national' },
  { date: '2026-02-15', name: 'Maha Shivaratri',         type: 'religious' },
  { date: '2026-03-04', name: 'Holi',                    type: 'religious' },
  { date: '2026-03-21', name: 'Eid ul-Fitr',             type: 'religious' },
  { date: '2026-03-27', name: 'Ram Navami',              type: 'religious' },
  { date: '2026-03-31', name: 'Mahavir Jayanti',         type: 'religious' },
  { date: '2026-04-03', name: 'Good Friday',             type: 'religious' },
  { date: '2026-04-14', name: 'Ambedkar Jayanti',        type: 'national' },
  { date: '2026-05-01', name: 'Labour Day / Buddha Purnima', type: 'national' },
  { date: '2026-05-27', name: 'Eid ul-Adha (Bakrid)',    type: 'religious' },
  { date: '2026-06-26', name: 'Muharram',                type: 'religious' },
  { date: '2026-08-15', name: 'Independence Day',        type: 'national' },
  { date: '2026-08-26', name: 'Onam (Thiruvonam)',       type: 'cultural', regional: true },
  { date: '2026-09-04', name: 'Janmashtami',             type: 'religious' },
  { date: '2026-09-14', name: 'Ganesh Chaturthi',        type: 'religious' },
  { date: '2026-09-25', name: 'Milad un-Nabi',           type: 'religious' },
  { date: '2026-10-02', name: 'Gandhi Jayanti',          type: 'national' },
  { date: '2026-10-20', name: 'Dussehra (Vijayadashami)',type: 'religious' },
  { date: '2026-11-08', name: 'Diwali',                  type: 'religious' },
  { date: '2026-11-11', name: 'Bhai Dooj',               type: 'religious' },
  { date: '2026-11-24', name: 'Guru Nanak Jayanti',      type: 'religious' },
  { date: '2026-12-25', name: 'Christmas Day',           type: 'religious' },

  // ── 2027 ─────────────────────────────────────────────────────────────────
  { date: '2027-01-01', name: "New Year's Day",          type: 'observance' },
  { date: '2027-01-14', name: 'Makar Sankranti / Pongal',type: 'cultural' },
  { date: '2027-01-26', name: 'Republic Day',            type: 'national' },
  { date: '2027-03-06', name: 'Maha Shivaratri',         type: 'religious' },
  { date: '2027-03-11', name: 'Eid ul-Fitr',             type: 'religious' },
  { date: '2027-03-22', name: 'Holi',                    type: 'religious' },
  { date: '2027-03-26', name: 'Good Friday',             type: 'religious' },
  { date: '2027-04-14', name: 'Ambedkar Jayanti',        type: 'national' },
  { date: '2027-04-15', name: 'Ram Navami',              type: 'religious' },
  { date: '2027-04-19', name: 'Mahavir Jayanti',         type: 'religious' },
  { date: '2027-05-01', name: 'Labour Day',              type: 'national' },
  { date: '2027-05-17', name: 'Eid ul-Adha (Bakrid)',    type: 'religious' },
  { date: '2027-05-20', name: 'Buddha Purnima',          type: 'religious' },
  { date: '2027-06-16', name: 'Muharram',                type: 'religious' },
  { date: '2027-08-15', name: 'Independence Day',        type: 'national' },
  { date: '2027-09-03', name: 'Ganesh Chaturthi',        type: 'religious' },
  { date: '2027-09-14', name: 'Milad un-Nabi',           type: 'religious' },
  { date: '2027-09-15', name: 'Onam (Thiruvonam)',       type: 'cultural', regional: true },
  { date: '2027-09-23', name: 'Janmashtami',             type: 'religious' },
  { date: '2027-10-02', name: 'Gandhi Jayanti',          type: 'national' },
  { date: '2027-10-09', name: 'Dussehra (Vijayadashami)',type: 'religious' },
  { date: '2027-10-28', name: 'Diwali',                  type: 'religious' },
  { date: '2027-10-31', name: 'Bhai Dooj',               type: 'religious' },
  { date: '2027-11-14', name: 'Guru Nanak Jayanti',      type: 'religious' },
  { date: '2027-12-25', name: 'Christmas Day',           type: 'religious' },
]

// Build a quick lookup: 'YYYY-MM-DD' → [holiday, holiday, …]
const HOLIDAYS_BY_DATE = HOLIDAYS.reduce((acc, h) => {
  if (!acc[h.date]) acc[h.date] = []
  acc[h.date].push(h)
  return acc
}, {})

export function getHolidaysForDate(dateStr) {
  return HOLIDAYS_BY_DATE[dateStr] || []
}

export function getHolidaysForMonth(year, monthIndex) {
  // monthIndex: 0-11
  const prefix = `${year}-${String(monthIndex + 1).padStart(2, '0')}-`
  return HOLIDAYS.filter((h) => h.date.startsWith(prefix))
}

export function getHolidaysInRange(startDate, endDate) {
  // startDate/endDate: 'YYYY-MM-DD'
  return HOLIDAYS.filter((h) => h.date >= startDate && h.date <= endDate)
}

export function getUpcomingHolidays(fromDateStr, limit = 5) {
  return HOLIDAYS
    .filter((h) => h.date >= fromDateStr)
    .slice(0, limit)
}
